"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SearchInputOption {
    constructor(label, value) {
        this.label = label;
        this.value = value;
    }
}
exports.default = SearchInputOption;
